import { DomainUser } from 'features/team/types'
import { DomainType } from 'features/domains/types'

export function checkUserIsAdmin(userData: DomainUser | undefined) {
  return userData?.domainPermissionDomain && userData?.domainPermissionUser
}

// users[0] because backend returns always one current user in array
export function getUserDataFromDomain(domain: DomainType | undefined) {
  return domain?.users?.[0]
}

export function checkUserIsAdminSomewhere(domains: DomainType[]): boolean {
  return domains.some((domain: DomainType) => {
    if (checkUserIsAdmin(getUserDataFromDomain(domain))) {
      return true
    } else if (domain.subDomains) {
      return checkUserIsAdminSomewhere(domain.subDomains)
    }

    return false
  })
}

export function getDomainsWhereUserIsAdmin(
  domains: DomainType[]
): DomainType[] {
  const domainsWhereUserIsAdmin: DomainType[] = []
  domains.forEach((domain: DomainType) => {
    if (checkUserIsAdmin(getUserDataFromDomain(domain))) {
      domainsWhereUserIsAdmin.push(domain)
    }
    if (domain.subDomains) {
      domainsWhereUserIsAdmin.push(
        ...getDomainsWhereUserIsAdmin(domain.subDomains)
      )
    }
  })

  return domainsWhereUserIsAdmin
}

export function checkUserIsDomainAdmin(
  domainId: string | undefined,
  domains: DomainType[]
): boolean {
  const userDomain = findDomainById(domainId, domains)
  const userDataFromDomain = getUserDataFromDomain(userDomain)
  if (checkUserIsAdmin(userDataFromDomain)) {
    return true
  } else if (userDomain?.parentDomainId) {
    return checkUserIsDomainAdmin(userDomain?.parentDomainId, domains)
  }

  return false
}

export function findDomainById(
  domainId: string | undefined,
  domains: DomainType[]
): DomainType | undefined {
  for (const domain of domains) {
    if (domain.id === domainId) {
      return domain
    } else if (domain.subDomains) {
      const found = findDomainById(domainId, domain.subDomains)
      if (found) {
        return found
      }
    }
  }

  return undefined
}
